import React from 'react';
import {Button} from 'react-bootstrap';
import {Modal} from 'react-bootstrap';
import {useIntl} from 'react-intl';


const PopupFailedUploadedAgents = ({
                                     showPopup,
                                     handleClosePopup,
                                     data = [],
                                   }) => {
  const intl = useIntl();
  const failedAgentsHeader = intl.formatMessage({
    id: 'receipts-popup-header-failed-agents',
    defaultMessage: 'Failed agents',
  });
  const columnFirstName = intl.formatMessage({
    id: 'receipts-popup-column-firstName',
    defaultMessage: 'Amount',
  });
  const columnLastName = intl.formatMessage({
    id: 'receipts-popup-column-lastName',
    defaultMessage: 'Amount',
  });
  const columnIdNumber = intl.formatMessage({
    id: 'receipts-popup-column-idNumber',
    defaultMessage: 'Amount',
  });
  const columnAmount = intl.formatMessage({
    id: 'receipts-popup-column-amount',
    defaultMessage: 'Amount',
  });
  const cancelButtonLabel = intl.formatMessage({
    id: 'label-button-cancel',
    defaultMessage: 'Cancel',
  });

  const headerCellClassName = 'header-cell w-25 px-1';

  const mapItem = (item, index) => {
    const cellClassname = 'w-25 text-center';
    return (
      <div className={'d-flex justify-content-between py-1'}>
        <div className={cellClassname}>{index + 1}</div>
        <div className={cellClassname}>{item.firstName}</div>
        <div className={cellClassname}>{item.lastName}</div>
        <div className={cellClassname}>{item.idNumber}</div>
        <div className={cellClassname}>{item.amount}</div>
      </div>
    )
  };

  const scrollPaddingClassName = data.length > 14 ? 'pr-6' : '';

  return (
    <Modal
      show={showPopup}
      onHide={handleClosePopup}
      className="mt-12"
      size={'lg'}
    >
      <Modal.Body>
        <h3 className="card-title font-weight-bold text-dark text-center mb-4">
          {failedAgentsHeader}
        </h3>
        <div className={`popup-failed-uploaded-agents`}>
          <div className={`d-flex justify-content-between custom-brand-color header ${scrollPaddingClassName}`}>
            <div className={headerCellClassName}>
              #
            </div>
            <div className={headerCellClassName}>
              {columnFirstName}
            </div>
            <div className={headerCellClassName}>
              {columnLastName}
            </div>
            <div className={headerCellClassName}>
              {columnIdNumber}
            </div>
            <div className={headerCellClassName}>
              {columnAmount}
            </div>
          </div>
        </div>
        <div className={'py-2 overflow-auto'} style={{maxHeight: '400px'}}>
          {data.map(mapItem)}
        </div>
        <div className={'d-flex justify-content-center mt-6'}>
          <Button
            type={'button'}
            className="btn btn-secondary btn-sm col-3"
            onClick={handleClosePopup}
          >
            {cancelButtonLabel}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PopupFailedUploadedAgents;
